import { render, staticRenderFns } from "./BannerNew.vue?vue&type=template&id=26e9f044&scoped=true&"
import script from "./BannerNew.vue?vue&type=script&lang=js&"
export * from "./BannerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e9f044",
  null
  
)

export default component.exports